import React from "react";
import ChangePassword from "../components/ChangePassword";
import ".././scss/views/ChangePasswordView.scss";

const ChangePasswordView = () => {
  return <ChangePassword />;
};

export default ChangePasswordView;
